"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYmAnalyticsId = exports.getYmId = exports.getYmIdValue = exports.COOKIE_YM_ID = exports.getProjectClientId = void 0;
var react_cookies_1 = __importDefault(require("react-cookies"));
var getProjectClientId = function () { var _a; return (_a = react_cookies_1.default.load('abn_test')) !== null && _a !== void 0 ? _a : 'client id abn_test is not defined'; };
exports.getProjectClientId = getProjectClientId;
function getKeyStartsWith(keys, prefix) {
    var result = keys.find(function (key) { return key.startsWith(prefix); });
    return result ? result : null;
}
/**
 * Пполучение YA clientId из yacounter
 */
var getYmClientId = function () {
    var _a;
    try {
        var yaCounterKey = getKeyStartsWith(Object.keys(window), 'yaCounter');
        if (yaCounterKey) {
            var clientId = ((_a = window[yaCounterKey]) === null || _a === void 0 ? void 0 : _a.getClientID()) || (0, exports.getProjectClientId)();
            return clientId !== null && clientId !== void 0 ? clientId : 'client id ym is not defined';
        }
        else {
            return 'yaCounter key not found in window keys';
        }
    }
    catch (e) {
        return 'window.ym is not defined';
    }
};
exports.COOKIE_YM_ID = '_ym_uid';
var getYmIdValue = function () {
    var clientYAId = react_cookies_1.default.load(exports.COOKIE_YM_ID);
    return clientYAId || getYmClientId();
};
exports.getYmIdValue = getYmIdValue;
/* @deprecated use getAnalyticsId and prop name "analyticsId" for backend and frontend */
var getYmId = function () {
    return {
        ymUid: (0, exports.getYmIdValue)(),
    };
};
exports.getYmId = getYmId;
var getYmAnalyticsId = function () {
    return {
        analyticsId: (0, exports.getYmIdValue)(),
    };
};
exports.getYmAnalyticsId = getYmAnalyticsId;
